export const VALIDATE_ORG = "VALIDATE_ORG";
export const RESET_ALL_STATE = "RESET_ALL_STATE";
export const ADD_ORGANIZATION = "ADD_ORGANIZATION";
export const GET_ORGANIZATION = "GET_ORGANIZATION";
export const UPDATE_USER_ROLES = "UPDATE_USER_ROLES";
